var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.333333, 1.333333)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66666667,0.000666666667 L1.33333333,0.000666666667 C0.598,0.000666666667 0,0.599333333 0,1.334 L0,4.66733333 C0,5.402 0.598,6.00066667 1.33333333,6.00066667 L4.66666667,6.00066667 C5.40266667,6.00066667 6,5.402 6,4.66733333 L6,1.334 C6,0.599333333 5.40266667,0.000666666667 4.66666667,0.000666666667 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0.000666666667 L8.66666667,0.000666666667 C7.93066667,0.000666666667 7.33333333,0.599333333 7.33333333,1.334 L7.33333333,4.66733333 C7.33333333,5.402 7.93066667,6.00066667 8.66666667,6.00066667 L12,6.00066667 C12.736,6.00066667 13.3333333,5.402 13.3333333,4.66733333 L13.3333333,1.334 C13.3333333,0.599333333 12.736,0.000666666667 12,0.000666666667 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66666667,7.334 L1.33333333,7.334 C0.598,7.334 0,7.93266667 0,8.66733333 L0,12.0006667 C0,12.736 0.598,13.334 1.33333333,13.334 L4.66666667,13.334 C5.40266667,13.334 6,12.736 6,12.0006667 L6,8.66733333 C6,7.93266667 5.40266667,7.334 4.66666667,7.334 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,7.334 L8.66666667,7.334 C7.93066667,7.334 7.33333333,7.93266667 7.33333333,8.66733333 L7.33333333,12.0006667 C7.33333333,12.736 7.93066667,13.334 8.66666667,13.334 L12,13.334 C12.736,13.334 13.3333333,12.736 13.3333333,12.0006667 L13.3333333,8.66733333 C13.3333333,7.93266667 12.736,7.334 12,7.334 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.099467a4ce383e4b17227c3cb808ae17.svg";
export { ForwardRef as ReactComponent };